module.exports = __webpack_public_path__ + "img/jam-sessions.5b9e88df.png";